export default "__VITE_ASSET__a41c5c85__"